import { initContract } from '@ts-rest/core'
import { ErrorResponseSchema } from '../../../shared/types'
import {
  NetsuiteProductMappingListResponseSchema,
  NetsuiteProductMappingQuerySchema,
} from './schemas'

const c = initContract()

export const netsuiteMappingContract = c.router(
  {
    getNetsuiteProductMappings: {
      method: 'GET',
      path: '/netsuite/product-mappings',
      summary: 'List Phoenix variant → NetSuite item mappings (internal)',
      description: 'Bulk fetch of every Phoenix product_variant_netsuite_mapping row. Consumed by the orchestration resolver to translate Phoenix variant IDs into NetSuite externalIds before posting Sales Orders. Set activeOnly=true to drop rows where is_active is false. Internal-only — no JWKS auth.',
      query: NetsuiteProductMappingQuerySchema,
      responses: {
        200: NetsuiteProductMappingListResponseSchema,
        500: ErrorResponseSchema,
      },
    },
  },
  { pathPrefix: '/api/v1' },
)
